import React from "react";
import { InputView, View, StyleSheet } from "react-native";  
import * as Colors from "../styles/colors"

export default function TextBox({ children, style }) {
    return <View style={[estilos.inputView, style]}>
        {children}
    </View>
}

const estilos = StyleSheet.create({
    inputView: {
        backgroundColor: Colors.WHITE,
        borderColor: Colors.INPUT_BORDER_COLOR,
        borderRadius: 8,
        height: 55,
        marginBottom: 20,
        alignItems: "flex-start",
        justifyContent: 'center',
        borderWidth: 1,
        width:'70%'
    },
})

